'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = SwiperGen;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

function SwiperGen() {
	var _swipers = document.querySelectorAll('.swiper-container');
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = _swipers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var el = _step.value;

			var mySwiper = new _swiper2['default'](el, {
				// Optional parameters
				direction: 'horizontal',
				loop: true,
				threshold: 50,
				// If we need pagination
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				// Navigation arrows
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}

			});
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator['return']) {
				_iterator['return']();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

module.exports = exports['default'];
// And if we need scrollbar
//scrollbar: '.swiper-scrollbar',
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdG91cmhla2xhLnVsdHJhbm9pci5jb20vYXNzZXRzL3NjcmlwdHMvcGFydGlhbHMvc3dpcGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUt3QixTQUFTOzs7O3NCQUxkLFFBQVE7Ozs7b0JBQ1YsTUFBTTs7OztzQkFDSixRQUFROzs7O0FBR1osU0FBUyxTQUFTLEdBQUc7QUFDbkMsS0FBTSxRQUFRLEdBQUcsUUFBUSxDQUFDLGdCQUFnQixDQUFDLG1CQUFtQixDQUFDLENBQUM7Ozs7OztBQUNoRSx1QkFBZ0IsUUFBUSw4SEFBQztPQUFmLEVBQUU7O0FBQ1gsT0FBSSxRQUFRLEdBQUcsd0JBQVksRUFBRSxFQUFFOztBQUU1QixhQUFTLEVBQUUsWUFBWTtBQUN2QixRQUFJLEVBQUUsSUFBSTtBQUNWLGFBQVMsRUFBRSxFQUFFOztBQUViLGNBQVUsRUFBRTtBQUNkLE9BQUUsRUFBRSxvQkFBb0I7QUFDeEIsY0FBUyxFQUFFLElBQUk7S0FDYjs7QUFFQSxjQUFVLEVBQUU7QUFDZCxXQUFNLEVBQUUscUJBQXFCO0FBQzdCLFdBQU0sRUFBRSxxQkFBcUI7S0FDM0I7O0lBSUQsQ0FBQyxDQUFBO0dBQ0g7Ozs7Ozs7Ozs7Ozs7OztDQUNEIiwiZmlsZSI6Ii9Vc2Vycy9iYWJlL1dvcmsvdG91cmhla2xhLnVsdHJhbm9pci5jb20vYXNzZXRzL3NjcmlwdHMvcGFydGlhbHMvc3dpcGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHB1YnN1YiBmcm9tICdwdWJzdWInO1xuaW1wb3J0IGdzYXAgZnJvbSAnZ3NhcCc7XG5pbXBvcnQgU3dpcGVyIGZyb20gJ3N3aXBlcic7XG5cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gU3dpcGVyR2VuKCkge1xuXHRjb25zdCBfc3dpcGVycyA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoJy5zd2lwZXItY29udGFpbmVyJyk7XG5cdGZvcihjb25zdCBlbCBvZiBfc3dpcGVycyl7XG5cdFx0bGV0IG15U3dpcGVyID0gbmV3IFN3aXBlciAoZWwsIHtcblx0ICAgIC8vIE9wdGlvbmFsIHBhcmFtZXRlcnNcblx0ICAgIGRpcmVjdGlvbjogJ2hvcml6b250YWwnLFxuXHQgICAgbG9vcDogdHJ1ZSxcblx0ICAgIHRocmVzaG9sZDogNTAsXG5cdCAgICAvLyBJZiB3ZSBuZWVkIHBhZ2luYXRpb25cblx0ICAgIHBhZ2luYXRpb246IHtcblx0XHRcdGVsOiAnLnN3aXBlci1wYWdpbmF0aW9uJyxcblx0XHRcdGNsaWNrYWJsZTogdHJ1ZSxcblx0XHQgIH0sXG5cdCAgICAvLyBOYXZpZ2F0aW9uIGFycm93c1xuXHQgICAgbmF2aWdhdGlvbjoge1xuXHRcdFx0bmV4dEVsOiAnLnN3aXBlci1idXR0b24tbmV4dCcsXG5cdFx0XHRwcmV2RWw6ICcuc3dpcGVyLWJ1dHRvbi1wcmV2JywgXG5cdFx0ICB9LFxuXHQgICAgXG5cdCAgICAvLyBBbmQgaWYgd2UgbmVlZCBzY3JvbGxiYXJcblx0ICAgIC8vc2Nyb2xsYmFyOiAnLnN3aXBlci1zY3JvbGxiYXInLFxuXHQgIH0pICAgICAgICBcblx0fVx0XG59Il19